<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1> 일렉트론 앱 버전 수정</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>버전 명<span class="forg">*</span></label>
            <ul class="w80">
              <li>
                <kendo-maskedtextbox
                    class="w75"
                    :class="{'error' : errorTarget === 'versionNm'}"
                    ref="versionNmRef"
                    v-model.trim="versionInfo.versionNm"
                    maxlength="50"
                    :placeholder="'버전명을 입력하세요.'">
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
          <dd>
            <label>타입<span class="forg">*</span></label>
            <ul class="w80">
              <div v-for="item in kioskUseScnList ">
                <input
                    class="k-radio"
                    type="radio"
                    name="kioskTypeRef"
                    v-model="versionInfo.kioskType"
                    :id="`${item.cdId}_useScn`"
                    :value="item.cdId"
                >
                <label :for="`${item.cdId}_useScn`" class="k-radio-label">{{ item.cdNm }} </label>
              </div>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>생성 일시</label>
            <ul class="w75">
              <li>
                {{ versionInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>버전 활성화<span class="forg">*</span></label>
            <ul class="w75">
              <li>
                <div v-for="item in [{cdId : 'Y', cdNm : '활성화' }, {cdId : 'N', cdNm : '비활성화' }]">
                  <input
                      class="k-radio"
                      type="radio"
                      name="useYn"
                      v-model="versionInfo.useYn"
                      :id="`${item.cdId}_useYn`"
                      :value="item.cdId">
                  <label :for="`${item.cdId}_useYn`" class="k-radio-label">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>일렉트론 앱 버전 업로드<span class="forg">*</span></label>
            <ul class="w65">
              <li>
                <version-file-upload
                    ref="fileUploadRef"
                    v-model="file"
                    :multiple="false"
                    :maxfile="1"
                    :allowed-extensions="['.exe']"
                    :layout="'DEFAULT'"
                ></version-file-upload>
              </li>
              <li v-show="file.length === 0" @click="getDownloadFile" >
                <span class="k-icon k-i-download"></span>
                {{ versionInfo.orgFileNm}}
              </li>
            </ul>
          </dd>
          <dd>
            <label>설명</label>
            <ul class="w75">
              <li>
                <kendo-maskedtextbox
                    class="w75"
                    ref="summaryRef"
                    v-model.trim="versionInfo.summary"
                    maxlength="100"
                    :placeholder="'버전 설명을 입력하세요.'">
                </kendo-maskedtextbox>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>적용 키오스크</label>
            <ul class="w65">
              <li>
                <dd>
                  <span style="width: 50%; text-align: center; ">{{ '키오스크 목록' }}</span>
                </dd>
                <dd>
                  <span style="width: 50%; text-align: center; margin-left: 15px">{{ '적용 키오스크' }}</span>
                </dd>
              </li>
              <li>
                <kendo-listbox id="optional"
                               class="kiosk_admin_option"
                               ref="optionalRef"
                               :draggable="true"
                               :connect-with="'selected'"
                               :drop-sources="['selected']"
                               :data-source="kioskList"
                               :data-text-field="'kioskNm'"
                               :data-value-field="'kioskNo'"
                               :toolbar-tools="['transferTo', 'transferFrom', 'transferAllTo', 'transferAllFrom']"
                               style="width: 50%;"
                >
                </kendo-listbox>
                <kendo-listbox id="selected"
                               class="kiosk_admin_option"
                               ref="selectedRef"
                               :draggable="true"
                               :connect-with="'optional'"
                               :drop-sources="['optional']"
                               :data-sources="selectedList"
                               :data-text-field="'kioskNm'"
                               :data-value-field="'kioskNo'"
                               style="width: 47%; margin-left: 2%"
                >
                </kendo-listbox>
              </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  상세 설명  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <label style="width: 9.5%;">상세 설명</label>
          <ul class="w75">
              <textarea
                  style="width: inherit; resize: none;"
                  ref="descriptionRef"
                  placeholder="상세 설명을 입력해 주세요."
                  v-model.trim="versionInfo.description"
                  maxlength="500"
              >
              </textarea>
          </ul>
        </li>
      </ul>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button type="button" class="large_btn" @click="redirectToList">목록</button>
        </li>
        <li class="w25">
          <button type="submit" class="large_btn orange" @click="onChangeSave">저장</button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>

import { LogisticsCodeDtlMixin } from '@/mixin/Mixin'
import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import { ListBox } from '@progress/kendo-listbox-vue-wrapper'
import SendFileUpload from '@/components/send/SendFileUpload.vue'
import VersionFileUpload from '@/components/VersionFileUpload.vue'
import Apiconfig from '@/api/api.config'
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: 'VersionUpdate',
  components: {
    VersionFileUpload,
    SendFileUpload,
    'kendo-listbox': ListBox
  },
  mixins: [LogisticsCodeDtlMixin],
  mounted () {
    const vm = this
    vm.getVersionInfo()
  },
  computed: {
  },
  methods: {
    // 버전 정보 호출 API
    getVersionInfo () {
      const vm = this
      const url = `${Apiconfig.eklDomain}/v1/ebmp/ai/manager/portal/electron/versionDetail.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        versionId: vm.$route.params.versionId,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.versionInfo = resultData
        vm.versionKioskList = resultData.versionKioskList
        vm.$refs.selectedRef.kendoWidget().setDataSource(vm.versionKioskList)
        // 키오스크 목록 세팅
        vm.getKioskList()
      })
    },
    // 키오스크 리스트 호출
    getKioskList () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/electron/kioskNmList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.kioskList = resultData
        // 키오스크 목록 데이터 세팅
        vm.kioskList = vm.removeDuplicates(vm.kioskList, vm.versionKioskList)
        vm.$refs.selectedRef.kendoWidget().setDataSource(vm.versionKioskList)
        vm.versionKioskList = []
      })
    },
    // 리스트 비교 후 중복 제거
    removeDuplicates(list1, list2){
      const vm = this
      return list1.filter(item1 => !list2.some(item2 => item1.kioskNo === item2.kioskNo));
      vm.$refs.optionalRef.kendoWidget().setDataSource(vm.kioskList)
    },
    // 등록 버튼
    async onChangeSave () {
      const vm = this
      if (vm.validation()) {
        await kendo.confirm('저장 하시겠습니까?').done(
          async function () {
            vm.saveVersion()
          })
      }
    },
    // 유효성 체크
    validation () {
      const vm = this
      const versionInfo = vm.versionInfo

      //필수값 체크
      if (EtnersCommonUtil.isEmpty(versionInfo.versionNm)) {
        kendo.alert('버전 명을 입력해주세요')
        vm.errorTarget = 'versionNm'
        return
      }
      else if(EtnersCommonUtil.isNotEmpty(versionInfo.versionNm)){
        const regVersion = /^esai-kiosk.*?(alpha|release)$/;
        if(!regVersion.test(versionInfo.versionNm)){
          kendo.alert('버전 명을 규칙에 맞게 입력해주세요 <br> 버전 명은 \'esai-kiosk\'로 시작하고 \'alpha\' 또는 \'release\'로 끝나야 합니다. ')
          vm.errorTarget = 'versionNm'
          return
        }
      }
      if (EtnersCommonUtil.isEmpty(versionInfo.kioskType)) {
        kendo.alert('버전 타입을 선택하세요')
        vm.errorTarget = null
        return
      }
      if (EtnersCommonUtil.isEmpty(versionInfo.useYn)) {
        kendo.alert('버전 활성화 여부를 선택하세요')
        vm.errorTarget = null
        return
      }
      if (EtnersCommonUtil.isEmpty(vm.file) && EtnersCommonUtil.isEmpty(versionInfo.fileId)) {
        kendo.alert('일렉트론 앱 버전을 업로드 하세요.')
        vm.errorTarget = null
        return
      }
      vm.errorTarget = null
      return true
    },
    // 등록 API
    saveVersion () {
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/electron/versionUpdate.json`
      const formData = new FormData()
      const updateVersionList = vm.$refs.selectedRef.kendoWidget().dataSource.data().map(item => item.kioskNo);
      const params = {
        loginUserToken: vm.loginUserToken,
        versionInfo: vm.versionInfo,
        updateVersionList: updateVersionList,
      }
      if(vm.file){
        vm.file.forEach(function (v) {``
          formData.append('file', v.rawFile)
        })
      }
      formData.append('versionUpdateRequestParam', new Blob([JSON.stringify(params)],{
        type: 'application/json',
      }))

      // API 호출
      ApiUtil.postIncludeUploadFile(url, formData).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        kendo.alert('등록되었습니다.')
        vm.redirectToList()
      })
    },
    // 버전 다운로드
    getDownloadFile () {
      const vm = this
      const downloadUrl = `${Apiconfig.eklDomain}/files/${vm.versionInfo.solCd}/${vm.versionInfo.fileId}/0?lutk=${vm.loginUserToken}`
      const a = document.createElement('a')
      a.href =  downloadUrl
      a.download = `${vm.versionInfo.versionNm}.exe`
      document.body.appendChild(a)
      a.click();
      document.body.removeChild(a);
    },
    // 목록으로 이동
    redirectToList () {
      this.$router.push({
        name: 'VersionList'
      })
    },
  },

  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      versionInfo: {
        versionNm: null,
        kioskType: null,
        useYn: null,
        summary: null,
        description: null,
        file: []
      },
      errorTarget: null,
      file: [],
      kioskList: [],
      versionKioskList: [],
      selectedList: [],
      updateVersionList: [],
    }
  }
}
</script>
